import { Img } from 'openimg/react'

export type ResponsiveMarketingImageProps = {
	src: string
	alt: string
	className?: string
	width?: number
	height?: number
	sizes?: string
	priority?: boolean
}

export function ResponsiveMarketingImage({
	src,
	alt,
	className,
	width = 1600,
	height = 900,
	sizes = '(min-width: 1024px) 50vw, 100vw',
	priority = false,
}: ResponsiveMarketingImageProps) {
	return (
		<Img
			src={src}
			alt={alt}
			className={className}
			width={width}
			height={height}
			sizes={sizes}
			loading={priority ? 'eager' : 'lazy'}
			decoding="async"
			isAboveFold={priority}
		/>
	)
}
